import {UntypedFormGroup, UntypedFormControl, Validators} from '@angular/forms';

export class EmailModel {
  emailForm = new UntypedFormGroup({
    'email': new UntypedFormControl(''),
    'tag': new UntypedFormControl('', [
      Validators.required,
    ]),
    'template': new UntypedFormControl('', [
      Validators.required,
    ]),
    'subject': new UntypedFormControl('', [
      Validators.required,
    ]),
    'attachment': new UntypedFormControl(''),
    'body': new UntypedFormControl('', [
      Validators.required,
    ])
  });
}
